import { environment } from '@lla-platform/core/core-util'

export const TECHNICIAN_API_URL = {
  laborSummary: `${environment.apiUrl}/labor/labor-summary-by-location`,
  exportLaborSummary: `${environment.apiUrl}/labor/labor-summary-by-location/export`,
  technicianSummary: `${environment.apiUrl}/employeeefficiency/back-desk-summary-by-location`,
  exportTechnicianSummary: `${environment.apiUrl}/employeeefficiency/back-desk-summary-by-location/export`,
  technicianList: `${environment.apiUrl}/employeeefficiency/back-desk-filters`,
  exportTechnicianList: `${environment.apiUrl}/employeeefficiency/back-desk-filters/export`,
  serviceAdvisorSummary: `${environment.apiUrl}/employeeefficiency/front-desk-summary-by-location`,
  exportServiceAdvisorSummary: `${environment.apiUrl}/employeeefficiency/front-desk-summary-by-location/export`,
  serviceAdvisorList: `${environment.apiUrl}/employeeefficiency/front-desk-filters`,
  exportServiceAdvisorList: `${environment.apiUrl}/employeeefficiency/front-desk-filters/export`,
  adminEfficiencyTargets: `${environment.apiUrl}/admin/efficiency-targets`
}
